import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';
const IndustryCard = ({
  item,
  index,
  linkText
}: {
  item: any;
  index: number;
  linkText: string;
}) => {
  const handleClick = () => {
    if (item.link) {
      window.open(item.link, '_blank', 'noopener,noreferrer');
    }
  };
  return <motion.div className="relative min-w-[280px] md:min-w-[350px] h-[400px] md:h-[500px] rounded-2xl overflow-hidden group cursor-pointer snap-center shrink-0" onClick={handleClick} initial={{
    opacity: 0,
    x: 50
  }} whileInView={{
    opacity: 1,
    x: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    delay: index * 0.2,
    duration: 0.6,
    ease: 'easeOut'
  }} data-id="element-115">
      {/* Background Image with Hover Scale */}
      <motion.div className="absolute inset-0 bg-cover bg-center transition-transform duration-700 ease-out group-hover:scale-110" style={{
      backgroundImage: `url(${item.image})`
    }} data-id="element-116" />

      {/* Overlay */}
      <div className="absolute inset-0 bg-black/60 transition-colors duration-500 group-hover:bg-black/40" data-id="element-117" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent" data-id="element-118" />

      {/* Content */}
      <div className="absolute inset-0 p-8 flex flex-col justify-end" data-id="element-119">
        <div className="text-4xl mb-4 transform transition-transform duration-500 group-hover:-translate-y-2" data-id="element-120">
          {item.icon}
        </div>
        <h3 className="text-2xl font-serif font-bold text-white transform transition-transform duration-500 group-hover:-translate-y-2" data-id="element-121">
          {item.title}
        </h3>
        <motion.div className="h-0 overflow-hidden opacity-0 group-hover:h-auto group-hover:opacity-100 group-hover:mt-4 transition-all duration-500" data-id="element-122">
          <p className="text-sm text-gray-300 font-medium tracking-wider uppercase" data-id="element-123">
            {linkText}
          </p>
        </motion.div>
      </div>
    </motion.div>;
};
export const Industries = () => {
  const {
    t
  } = useLanguage();
  const cards = t('industries.cards');
  const industries = [{
    icon: '💇',
    title: cards[0].title,
    image: 'https://images.unsplash.com/photo-1560066984-138dadb4c035?q=80&w=1000&auto=format&fit=crop',
    link: 'https://legaragesalon.com/'
  }, {
    icon: '🩺',
    title: cards[1].title,
    image: 'https://images.unsplash.com/photo-1631217868264-e5b90bb7e133?q=80&w=1000&auto=format&fit=crop',
    link: 'https://esteticamottura.com/?https%3A%2F%2Fwww_esteticamottura_com%2F&gad_source=1&gad_campaignid=23804187584&gbraid=0AAAAAC-VTxKcAVBZfoyWRY4Mt3Mg87od_&gclid=Cj0KCQjw8PDPBhCeARIsAOJwmWUJ6UIo5tRN3lfz5Ns8MTFcOuVY_zeSvf5-96hUi0_knv4JvTGyV5oaAqM3EALw_wcB'
  }, {
    icon: '🏋️',
    title: cards[2].title,
    image: 'https://images.unsplash.com/photo-1534438327276-14e5300c3a48?q=80&w=1000&auto=format&fit=crop',
    link: 'https://chaverosports.com.ar/?gad_source=1&gad_campaignid=23748010978&gbraid=0AAAABDWj4ci5M8Fbsrdtfer4hqhobUdsT&gclid=Cj0KCQjw8PDPBhCeARIsAOJwmWV98m2rpBlYZ_XAAuT9yGe-ROYzN-zkzHNTObq97JzCGZ37SOOlNCMaAhAEEALw_wcB'
  }, {
    icon: '🏠',
    title: cards[3].title,
    image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?q=80&w=1000&auto=format&fit=crop',
    link: 'https://villarobles.com.ar/?gad_source=1&gad_campaignid=21728750602&gbraid=0AAAAA-Nkiv45qOMrHHODjl2HS4ybeK8vT&gclid=Cj0KCQjw8PDPBhCeARIsAOJwmWWqSvwbt-8Tk06lUIe-vaube2-Oh0nmPRkS7Y79Xij5w41IGRaAM2waAprxEALw_wcB'
  }];
  return <section className="py-32 bg-background overflow-hidden" data-id="element-124">
      <div className="container mx-auto px-6 mb-16" data-id="element-125">
        <motion.h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-4" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-126">
          {t('industries.heading')}
        </motion.h2>
        <motion.p className="text-xl text-text-secondary" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-127">
          {t('industries.subheading')}
        </motion.p>
      </div>

      {/* Horizontal Scroll Container */}
      <div className="w-full overflow-x-auto pb-12 pt-4 px-6 snap-x snap-mandatory hide-scrollbar" data-id="element-128">
        <div className="flex gap-6 md:gap-8 w-max mx-auto md:mx-0 md:px-6" data-id="element-129">
          {industries.map((item, i) => <IndustryCard key={i} item={item} index={i} linkText={item.link ? t('industries.linkSingle') : t('industries.linkPlural')} data-id="element-130" />)}
        </div>
      </div>

      <style dangerouslySetInnerHTML={{
      __html: `
        .hide-scrollbar::-webkit-scrollbar { display: none; }
        .hide-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
      `
    }} data-id="element-131" />
    </section>;
};